import { FilePickerButton } from './ui/FilePickerButton'
export const AdminImageGrid = ({ imgObj, onFileChange }) => {
    return (
        <>
            <FilePickerButton onFileChange={onFileChange} />
        </>
    )
}
